import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ClassHelper } from '../../helpers/translateDefaultClass';
import { queries } from 'src/config/queries';
import { EntityTypes } from 'src/core/services/upload/constants';
import { StringHelper } from 'src/shared/helpers/string';
import { useCombineQueries } from 'src/shared/hooks/useCombineQueries';
function mapLiberation(liberation) {
    return {
        releaseDays: liberation?.type === 'BY_DAYS' && liberation.liberationDays >= 0
            ? liberation.liberationDays
            : null,
        releaseDate: (liberation?.type === 'BY_DATE' && liberation.liberationDate) || null,
        pageId: (liberation?.type === 'BY_QUIZ' && liberation.pageId) || null
    };
}
function mapDripping(dripping, t) {
    return {
        isUpdated: false,
        id: dripping.id,
        key: StringHelper.generateUUID(),
        allClasses: dripping.classes.length === 0,
        expirationDays: dripping.expiration?.durationDays ?? null,
        classes: ClassHelper.translateDefaultClass(dripping.classes, t),
        ...mapLiberation(dripping.liberation)
    };
}
function mapContent(t, data) {
    return {
        tags: data?.tags ?? [],
        name: data?.page.name ?? '',
        content: data?.page.content ?? '',
        published: data?.page.published,
        complementaryReadings: data?.complementaryReadings ?? [],
        drippings: data?.page.drippingConfigs.map((dripping) => mapDripping(dripping, t)) ?? []
    };
}
function mapMedias(data) {
    return { medias: data ?? [] };
}
function mapAttachments(data) {
    return { attachments: data ?? [] };
}
function mapCover(data) {
    const cover = data?.[0];
    return {
        cover: cover?.id
            ? {
                id: cover.id,
                name: cover.name,
                url: cover.thumborSignedUrl
            }
            : null
    };
}
export function getInitialValues() {
    return {
        name: '',
        content: '',
        medias: [],
        attachments: [],
        published: false,
        complementaryReadings: [],
        tags: [],
        drippings: [],
        cover: null
    };
}
export function useFillFormForUpdate({ pageId }) {
    const { t } = useTranslation();
    const { reset } = useFormContext();
    const isUpdate = Boolean(pageId) && pageId !== 'new';
    const [isFormLoading, setIsFormLoading] = useState(isUpdate);
    const combinedQueries = useCombineQueries([
        { ...queries.content.byId(pageId), enabled: isUpdate, staleTime: 0 },
        {
            ...queries.upload.filesByEntityType(pageId, EntityTypes.PageMedia),
            enabled: isUpdate,
            staleTime: 0
        },
        {
            ...queries.upload.filesByEntityType(pageId, EntityTypes.PageAttachment),
            enabled: isUpdate,
            staleTime: 0
        },
        {
            ...queries.upload.filesByEntityType(pageId, EntityTypes.PageBackgroundImg),
            enabled: isUpdate,
            staleTime: 0
        }
    ]);
    const [content, media, attachment, cover] = combinedQueries.data;
    useEffect(function effectFillForm() {
        if (combinedQueries.isSuccess) {
            const values = {
                ...mapContent(t, content),
                ...mapMedias(media),
                ...mapAttachments(attachment),
                ...mapCover(cover)
            };
            reset(values);
            setIsFormLoading(false);
        }
        if (combinedQueries.isError) {
            setIsFormLoading(false);
        }
    }, [
        reset,
        content,
        media,
        attachment,
        cover,
        combinedQueries.isSuccess,
        combinedQueries.isError,
        t
    ]);
    return { ...combinedQueries, isFormLoading };
}
